/**
 * This is a program to implement the Observer pattern in JavaScript.
 */

import AnalyticsSettings from "@/modules/analyticsLibrary/AnalyticsSettings"
import BlackholeService from "./BlackholeService";
import KinesisService from "./KinesisService";

/**
 * The Analytics Manager "class" constructor.
 */
class AnalyticsManager {
  constructor() {
    this.observers = [];
    this.analyticsSettingsObj = new AnalyticsSettings();
    this.settings = this.analyticsSettingsObj.getAnalyticsSettings();
  }

  /**
   *
   * @param eventType the event type of the user
   * @param route the tab from which the event was called
   * @param element element info
   * @param timestamp time string in ISO string format for eg  `toISOString`
   * This fn will notify each service and provide them with data and each service will
   * handle the data and event type on it's own
   */
  logEvent(eventType, route, element, timestamp) {
    if (eventType && route && element && timestamp) {
      const {ipaddress,userAgent,sessionID,userID} = this.settings;
      const log = {
        ipaddress,
        userAgent,
        sessionID,
        userID,
        eventType,
        data: {
          route,
          element,
          timestamp,
        }
      }
      this.notify(log);
    }
  }

  /**
   * Register an observer with the subject.
   *
   * @param {Object} service the observer registering with the subject
   */
  addObservers(service) {
    this.observers.push(service);
  }

  /**
   * Remove a previously registered observer from the subject's notification list.
   *
   * @param {Object} service the observer detaching from the subject
   */
  removeObserver(service) {
    let index = this.observers.indexOf(service, 0);
    if (index > -1 && service === this.observers[index]) {
      this.observers.splice(index, 1);
    } else {
      console.log('Service not found!', service);
    }
  }

  /**
   * Notify all observers of a change in the subject's data.
   */
  notify(log) {
    this.observers.forEach(o => {
      if(o.sendEvent) o.sendEvent(log);
    });
  }

  initLoggers(){
    for (let logger of LOGGER_TYPE.split(",")) {
      if (logger.toLocaleLowerCase() === 'blackhole') this.addObservers(new BlackholeService())
      else if (logger.toLocaleLowerCase() === 'kinesis') this.addObservers(new KinesisService())
    }
  }
}

export default AnalyticsManager;



// WEBPACK FOOTER //
// ./src/modules/analyticsLibrary/AnalyticsManager.js